import React, { useState, useEffect } from 'react';
import EditBarDialog from './components/EditBarDialog';
import { useEditBarDialog } from './EditBarDialogContext';

const GlobalEditBarDialog = () => {
  const { 
    showEditDialog, 
    editingBarData, 
    closeEditDialog, 
    onSaveCallback, 
    onDeleteCallback 
  } = useEditBarDialog();

  // Local state for dialog
  const [editTitle, setEditTitle] = useState('');
  const [editTextColor, setEditTextColor] = useState('#ffffff');
  const [editBackgroundColor, setEditBackgroundColor] = useState('#007bff');
  const [editBorderStyle, setEditBorderStyle] = useState('solid');
  const [editBorderColor, setEditBorderColor] = useState('#0056b3');
  const [editBorderThickness, setEditBorderThickness] = useState(1);
  const [editStartDate, setEditStartDate] = useState(null);
  const [editEndDate, setEditEndDate] = useState(null);
  const [editLinkEvidence, setEditLinkEvidence] = useState(false);
  const [editEvidenceType, setEditEvidenceType] = useState('manual');
  const [editEvidenceLabel, setEditEvidenceLabel] = useState('');
  const [editEvidenceDueDays, setEditEvidenceDueDays] = useState(30);
  const [editEvidenceData, setEditEvidenceData] = useState({});
  const [editKlassensynchronisation, setEditKlassensynchronisation] = useState('');

  // Update state when bar data changes
  useEffect(() => {
    if (editingBarData) {
      setEditTitle(editingBarData.label || '');
      setEditTextColor(editingBarData.textColor || '#ffffff');
      setEditBackgroundColor(editingBarData.backgroundColor || '#007bff');
      setEditBorderStyle(editingBarData.borderStyle || 'solid');
      setEditBorderColor(editingBarData.borderColor || '#0056b3');
      setEditBorderThickness(editingBarData.borderThickness || 1);
      setEditStartDate(editingBarData.startDate || null);
      setEditEndDate(editingBarData.endDate || null);
      setEditLinkEvidence(editingBarData.linkEvidence || false);
      setEditEvidenceType(editingBarData.evidenceType || 'manual');
      setEditEvidenceLabel(editingBarData.evidenceLabel || '');
      setEditEvidenceDueDays(editingBarData.evidenceDueDays || 30);
      setEditEvidenceData(editingBarData.evidenceData || {});
      setEditKlassensynchronisation(editingBarData.klassensynchronisation || '');
    } else {
      // Reset all fields for new tasks
      setEditTitle('');
      setEditTextColor('#ffffff');
      setEditBackgroundColor('#007bff');
      setEditBorderStyle('solid');
      setEditBorderColor('#0056b3');
      setEditBorderThickness(1);
      setEditStartDate(null);
      setEditEndDate(null);
      setEditLinkEvidence(false);
      setEditEvidenceType('manual');
      setEditEvidenceLabel('');
      setEditEvidenceDueDays(30);
      setEditEvidenceData({});
      setEditKlassensynchronisation('');
    }
  }, [editingBarData]);

  const handleEditSave = (additionalData = {}) => {
    if (onSaveCallback && editingBarData) {
      // Use evidenceData from EditBarDialog if provided, otherwise use local state
      const finalEvidenceData = additionalData.evidenceData || editEvidenceData;
      
      // Also update local state if new data is provided
      if (additionalData.evidenceData) {
        setEditEvidenceData(additionalData.evidenceData);
      }
      
      onSaveCallback(editingBarData.id, {
        label: editTitle,
        textColor: editTextColor,
        backgroundColor: editBackgroundColor,
        borderStyle: editBorderStyle,
        borderColor: editBorderColor,
        borderThickness: editBorderThickness,
        startDate: editStartDate,
        endDate: editEndDate,
        linkEvidence: editLinkEvidence,
        evidenceType: editEvidenceType,
        evidenceLabel: editEvidenceLabel,
        evidenceDueDays: editEvidenceDueDays,
        evidenceData: finalEvidenceData,
        klassensynchronisation: editKlassensynchronisation
      });
    }
    closeEditDialog();
  };

  const handleEditCancel = () => {
    closeEditDialog();
  };

  const handleEditDelete = () => {
    if (onDeleteCallback && editingBarData) {
      onDeleteCallback(editingBarData.id);
    }
    closeEditDialog();
  };

  if (!showEditDialog) {
    return null;
  }

  return (
    <>
      {/* Backdrop */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          zIndex: 99999 // Sehr hoher z-index für Top-Level
        }}
        onClick={handleEditCancel}
      />
      
      {/* Dialog */}
      <EditBarDialog
        editTitle={editTitle}
        setEditTitle={setEditTitle}
        editTextColor={editTextColor}
        setEditTextColor={setEditTextColor}
        editBackgroundColor={editBackgroundColor}
        setEditBackgroundColor={setEditBackgroundColor}
        editBorderStyle={editBorderStyle}
        setEditBorderStyle={setEditBorderStyle}
        editBorderColor={editBorderColor}
        setEditBorderColor={setEditBorderColor}
        editBorderThickness={editBorderThickness}
        setEditBorderThickness={setEditBorderThickness}
        editStartDate={editStartDate}
        setEditStartDate={setEditStartDate}
        editEndDate={editEndDate}
        setEditEndDate={setEditEndDate}
        editLinkEvidence={editLinkEvidence}
        setEditLinkEvidence={setEditLinkEvidence}
        editEvidenceType={editEvidenceType}
        setEditEvidenceType={setEditEvidenceType}
        editEvidenceLabel={editEvidenceLabel}
        setEditEvidenceLabel={setEditEvidenceLabel}
        editEvidenceDueDays={editEvidenceDueDays}
        setEditEvidenceDueDays={setEditEvidenceDueDays}
        editEvidenceData={editEvidenceData}
        setEditEvidenceData={setEditEvidenceData}
        editKlassensynchronisation={editKlassensynchronisation}
        setEditKlassensynchronisation={setEditKlassensynchronisation}
        onSave={handleEditSave}
        onCancel={handleEditCancel}
        onDelete={handleEditDelete}
        titlePlaceholder="Balken-Titel eingeben"
      />
    </>
  );
};

export default GlobalEditBarDialog;
